import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../Header"
import Footer from '../components/Footer'
import { fetchCategoryDropdown } from "../../../slice/category/categorySlice";
import { fetchUserProducts } from '../../../slice/product/productSlice';
import { useNavigate } from "react-router-dom";

const Home = () => {
  const dispatch = useDispatch();
 const navigate = useNavigate();
  localStorage.getItem("userId");
  localStorage.getItem("token");

  const { dropdownCategories = [], loading: categoryLoading } = useSelector(
    (state) => state.category
  );




  useEffect(() => {
    const loadData = async () => {
      try {
        await dispatch(fetchCategoryDropdown());
        await dispatch(fetchUserProducts({ page: 1, limit: 10 })).unwrap();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    loadData();
  }, [dispatch]);




  return (
    <div className="page-wraper">
<Header
  dropdownCategories={dropdownCategories}
  loading={categoryLoading}

/>


        {/*Swiper Banner Start */}
      <div className="page-content bg-light ">
  {/*banner*/}
  <div className="contact-bnr bg-light">
    <div className="container marginTOP100">
      <div className="row">
        <div className="col-lg-6">
          <div className="contact-info style-1 text-start text-white">
            <h2 className="title wow fadeInUp" data-wow-delay="0.1s">
              DISCOVER US
            </h2>
            <p className="text wow fadeInUp" data-wow-delay="0.2s">
             
           Our experts are available to answer any questions you might
              have. We’ve got the answers.
            </p>
            <div className="contact-bottom wow fadeInUp" data-wow-delay="0.3s">
              <div className="contact-left">
                <h3>Call Us</h3>
                <ul>
                  <li>04651 - 250-827</li>
                  <li>8903-8010-89</li>
                  
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div
            className="contact-area1 style-1 m-r20 m-md-r0 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <form
              className="dz-form dzForm"
            
            
            >
              <input
                type="hidden"
                className="form-control"
                name="dzToDo"
                defaultValue="Contact"
              />
              <input
                type="hidden"
                className="form-control"
                name="reCaptchaEnable"
                defaultValue={0}
              />
              <div className="dzFormMsg" />
              <label className="form-label">Your Name</label>
              <div className="input-group">
                <input
                  required=""
                  type="text"
                  className="form-control"
                  name="dzName"
                />
              </div>
              <label className="form-label">Email Address</label>
              <div className="input-group">
                <input
                  required=""
                  type="text"
                  className="form-control"
                  name="dzEmail"
                />
              </div>
              <label className="form-label">Phone Number</label>
              <div className="input-group">
                <input
                  required=""
                  type="text"
                  className="form-control"
                  name="dzPhoneNumber"
                />
              </div>
              <label className="form-label">Message</label>
              <div className="input-group m-b30">
                <textarea
                  name="dzMessage"
                  rows={4}
                  required=""
                  className="form-control m-b10"
                  defaultValue={""}
                />
              </div>
              <div className="input-recaptcha m-b30">
                <div
                  className="g-recaptcha"
                  data-sitekey="6LefsVUUAAAAADBPsLZzsNnETChealv6PYGzv3ZN"
                  data-callback="verifyRecaptchaCallback"
                  data-expired-callback="expiredRecaptchaCallback"
                />
                <input
                  className="form-control d-none"
                  style={{ display: "none" }}
                  data-recaptcha="true"
                  required=""
                  data-error="Please complete the Captcha"
                />
              </div>
              <div>
                <button
                  name="submit"
                  type="submit"
                  value="submit"
                  className="btn w-100 btn-white btnhover"
          
                     onClick={(e) => {

    navigate("/");
  }}
                >
                  SUBMIT
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

    <div className="map-iframe map">
    
   
  </div>
</div>




      {/* Footer */}
      <Footer />

  

 
    </div>
  )
}

export default Home